module.exports = __webpack_public_path__ + "static/media/17_1.c7476300.png";